<script setup>
import { ref } from "vue";
import { usePage } from "@inertiajs/vue3";

import MaterialIcon from "../MaterialIcon.vue";
import NavLink from "./NavLink.vue";

const props = defineProps({
  collapse: {
    type: Boolean,
    required: false,
    default: false,
  },
  short: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  menu_items: {
    type: Object,
    required: true,
  },
});

const page = usePage();

const segment_expanded = ref("false");

const toggle_segment_expanded = () => {
  segment_expanded.value = !segment_expanded.value;
};
</script>

<template>
  <div v-if="menu_items.length > 0">
    <!-- Separator -->
    <div
      class="separator"
      :class="collapse ? 'collapsed' : ''"
      @dblclick="toggle_segment_expanded"
    >
      <!-- Label -->
      <p>{{ collapse ? short : title }}</p>
      <!-- Toggle Button -->
      <button v-show="!collapse" @click.prevent="toggle_segment_expanded">
        <MaterialIcon v-if="segment_expanded" icon_name="expand_less" />
        <MaterialIcon v-else icon_name="expand_more" />
      </button>
    </div>

    <!-- Menu Items -->
    <div class="menu-segment" :class="segment_expanded ? 'show' : 'hide'">
      <!-- for item in and if item contains children -> for items in -->
      <ul>
        <li v-for="menu_item in menu_items">
          <NavLink
            :collapse="collapse"
            :href="menu_item.href"
            :icon_name="menu_item.icon_name"
            :text="menu_item.text"
            :children="menu_item.children"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.separator {
  cursor: pointer;
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 3rem;
  margin-bottom: 1.5rem;
  padding-top: 0.5rem;
  border-top: solid 1px var(--clr-text-subtile);

  &.collapsed {
    justify-content: center;
  }

  & > * + * {
    margin-left: 1rem;
  }

  button {
    display: flex;
    align-items: center;
  }

  button,
  p {
    color: var(--clr-text-subtile);
  }

  p {
    @include ff-menu-separator;
  }
}

.menu-segment {
  transition: max-height 400ms ease-in-out;
  overflow: hidden;
  max-height: 0;

  padding-left: 0.75rem;
  padding-right: 0.75rem;
  margin-left: -1rem;
  margin-right: -1rem;

  &.show {
    max-height: 100%;
  }

  ul {
    padding: 0.25rem;

    & > li + li {
      margin-top: 0.25rem;
    }
  }
}

/* transition */
@keyframes expand {
  0% {
    max-height: 0;
    border-bottom-color: transparent;
  }

  50% {
    border-bottom-color: var(--clr-text-subtile);
  }

  100% {
    max-height: 100%;
    border-bottom-color: transparent;
  }
}
</style>
